import { QIcon_chevron_bold_left } from '@repo/icons/index'
import { format } from 'date-fns'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import { s_blog } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'
import { useIsPopCookie } from '../../../../store/useScrollRestoreOnBack'

const BlogDetailDesktopTitleSection = ({ post, noBackButton = false }) => {
  const router = useAppRouter()
  const date = new Date(post.publishedAt)
  const formattedDate = format(date, 'yyyy.MM.dd')
  const { t } = useTranslation()
  const { setIsPopCookie } = useIsPopCookie()

  const navigateBackOrRedirect = () => {
    setIsPopCookie()
    router.back()
  }

  return (
    <div className={style.titleSectionLayout}>
      {!noBackButton && (
        <div className={style.goBackSection} onClick={() => navigateBackOrRedirect()}>
          <QIcon_chevron_bold_left color={COLORS.BLACK} className="h-[16px] w-[16px]" />
          <div>{t(s_blog.detail_page.btn)}</div>
        </div>
      )}

      <div className={style.categorySectionLayout}>
        <div className={style.categorySection}>
          <div className="">{post.category} </div>
          <div className="border-r-1 mx-[12px] h-[12px]"></div>
          <div className="">{post.subCategory} </div>
        </div>
      </div>
      <h1 className={style.titleSection}>{post.title}</h1>
      <h2 className={style.dateSection}>{formattedDate}</h2>
    </div>
  )
}

export default BlogDetailDesktopTitleSection

const style = {
  titleSectionLayout: `mb-[20px]`,
  goBackSection: `Body1-16Bd mb-[28px] flex cursor-pointer flex-row items-center`,
  categorySectionLayout: `flex justify-center `,
  categorySection: `Body1-16Md flex flex-row items-center text-gray-700`,
  titleSection: `Hero3-36Bd my-[20px] flex justify-center text-center keep-all`,
  dateSection: `Body1-16Md flex justify-center text-center text-gray-400`,
}
